import { render } from "./InternalTransfers.vue?vue&type=template&id=42397de4&ts=true"
import script from "./InternalTransfers.vue?vue&type=script&lang=ts"
export * from "./InternalTransfers.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\Users\\khale\\CookiesBIS\\Core\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__